<template>
  <div class="upload-container">
    <el-button
      :style="{ background: color, borderColor: color }"
      icon="el-icon-upload"
      size="mini"
      type="primary"
      @click="dialogVisible = true"
      >图片上传</el-button
    >
    <el-dialog :visible.sync="dialogVisible">
      <el-upload
        :multiple="true"
        :file-list="fileList"
        :show-file-list="true"
        :on-remove="handleRemove"
        :on-success="handleSuccess"
        :before-upload="beforeUpload"
        accept=".jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.GIF"
        action
        class="editor-slide-upload"
        list-type="picture-card"
        :http-request="uploadRequest"
      >
        <el-button size="small" type="primary">点击上传</el-button>
      </el-upload>
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 认</el-button>
    </el-dialog>
  </div>
</template>

<script>
import { Dialog, Upload } from 'element-ui';
import { upload } from '@/api';

export default {
  name: 'EditorSlideUpload',
  components: {
    ElDialog: Dialog,
    ElUpload: Upload
  },
  props: {
    color: {
      type: String,
      default: '#1890ff'
    },
    actionType: {
      type: Object,
      default() {
        return {
          def: true,
          action: () => ({})
        };
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      listObj: {},
      fileList: []
    };
  },
  methods: {
    checkAllSuccess() {
      return Object.keys(this.listObj).every(item => this.listObj[item].hasSuccess);
    },
    handleSubmit() {
      if (!this.checkAllSuccess()) {
        this.$message.warning('请等待图片上传完成，如有异常请刷新页面重新上传！');
        return;
      }
      this.$emit('successCBK', this.listObj);
      this.listObj = {};
      this.fileList = [];
      this.dialogVisible = false;
    },
    handleSuccess(response, file) {
      const { uid } = file;
      const objKeyArr = Object.keys(this.listObj);
      for (let i = 0, len = objKeyArr.length; i < len; i += 1) {
        if (this.listObj[objKeyArr[i]].uid === uid) {
          this.listObj[objKeyArr[i]].url = response.file_id;
          this.listObj[objKeyArr[i]].hasSuccess = true;
          return;
        }
      }
    },
    handleRemove(file) {
      const { uid } = file;
      const objKeyArr = Object.keys(this.listObj);
      for (let i = 0, len = objKeyArr.length; i < len; i += 1) {
        if (this.listObj[objKeyArr[i]].uid === uid) {
          delete this.listObj[objKeyArr[i]];
          return;
        }
      }
    },
    beforeUpload(file) {
      const self = this;
      const URL = window.URL || window.webkitURL;
      const fileName = file.uid;
      this.listObj[fileName] = {};
      return new Promise(resolve => {
        const img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = () => {
          self.listObj[fileName] = {
            hasSuccess: false,
            uid: file.uid,
            width: img.width,
            height: img.height
          };
        };
        resolve(true);
      });
    },
    uploadRequest(option) {
      const formData = new FormData();
      formData.append('file', option.file);
      const uploadAction = this.actionType.def ? upload : this.actionType.action;
      uploadAction({
        headers: { 'Content-Type': 'multipart/form-data' },
        method: 'post',
        data: formData,
        onUploadProgress: progressEvent => {
          // 原生获取上传进度的事件
          if (progressEvent.lengthComputable) {
            // 属性lengthComputable主要表明总共需要完成的工作量和已经完成的工作是否可以被测量
            // 如果lengthComputable为false，就获取不到progressEvent.total和progressEvent.loaded
            option.onProgress({ percent: Math.floor((progressEvent.loaded / progressEvent.total) * 99) }); // 触发el-upload组件的onProgress方法
          }
        }
      }).then(res => {
        option.onProgress({ percent: 100 });
        if (res && res.data) {
          option.onSuccess(res.data, option.file); // 触发el-upload组件的onSuccess方法
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.editor-slide-upload {
  margin-bottom: 20px;
  /deep/ .el-upload--picture-card {
    width: 100%;
  }
}
</style>
